import module from 'clientes/module.js'
import template from './template.html'

export class ClientesBuscarComponent {
  data = null
  isAdmin = false

  constructor (ClientesBuscar) {
    this.ClientesBuscar = ClientesBuscar
  }

  $onInit () {
    this.promise = this.ClientesBuscar.get()
      .then(({data}) => {
        this.data = data.resultados
        this.isAdmin = data.admin
      })
  }
}

module.component('clientesBuscar', {
  controller: ClientesBuscarComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/clientes/components/buscar/component.js